import {getElement} from "./utils/getElement";

const initDashboard = () => {
    const dashboardNavToggle = getElement('.js-account-nav-toggle')
    const dashboardNav = getElement('.js-dashboard-nav')

    if (!dashboardNavToggle && !dashboardNav) {
        return;
    }

    dashboardNavToggle.addEventListener('click', () => {
        if (dashboardNav.classList.contains('is-open')) {
            dashboardNav.classList.remove('is-open')
            dashboardNav.style.maxHeight = null;
            dashboardNav.style.opacity = '0';
        } else {
            dashboardNav.classList.add('is-open')
            dashboardNav.style.maxHeight = (dashboardNav.scrollHeight + 32) + "px";
            dashboardNav.style.opacity = '1';
        }
    })
}

export {initDashboard}
